module.exports = __webpack_public_path__ + "img/value-intro-01.1b0e75c7.jpg";